import React from "react";

export const AuthContext: any = React.createContext({});